import React from "react";

function BitcoinWalletHero() {
  return (
    <>
      <div
        className="banner-style-two-area bg-theme shadow theme text-light bg-cover"
        style={{
          background:
            "url(assets/img/bg/white_label_crypto_exchange_image.jpg)",
        }}
      >
        <div className="container">
          <div className="row align-center">
            <div className="col-xl-7 col-lg-8">
              <div className="banner-two-content">
                <h2 className="split-text-right split-text-in-right">
                  Bitcoin Wallet Development
                </h2>
                <div className="info">
                  <p className="fade-up-anim">
                    Launch a Bitcoin wallet to host a platform for storing the
                    largest and widely adopted cryptocurrency.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default BitcoinWalletHero;
